import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {getAutocompleteValue} from 'src/infrastructure/helper/autocomplete-helper';
import {AdxPaymentResponse} from '../models/adx-payment';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AdxPaymentGridService implements GridGetService<AdxPaymentResponse> {
  private readonly baseUrl = 'dbov2/adx-payment-detail/search';
  private readonly http = inject(HttpClient);

  private extractFilterValue(val: any): string | number | null {
    if (val && typeof val === 'object') {
      if ('id' in val) return val.id;
      if ('value' in val) return val.value;
    }
    if (typeof val === 'string' && val.trim() !== '') return val;
    if (typeof val === 'number') return val;
    return null;
  }

  private getAutocompleteValueForIdField(value: any): string | number {
    const id = this.extractFilterValue(value);
    if (id !== null) {
      return id;
    }
    return getAutocompleteValue(value) || '';
  }

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<AdxPaymentResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: this.getMappedPaymentPropertyName(sort?.active || ''),
      orderKey: sort?.direction || '',

      payTypeId: filters?.['payTypeId'] ?? '',
      paymentDateFrom: filters?.['paymentDateFrom'] ? moment(filters?.['paymentDateFrom']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      paymentDateTo: filters?.['paymentDateTo'] ? moment(filters?.['paymentDateTo']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      profileTypeCode: filters?.['profileTypeCode'] ?? '',
      payMethodId: filters?.['payMethodId'] ?? '',
      BranchId: this.getAutocompleteValueForIdField(filters?.['branchId']),
      BankId: this.getAutocompleteValueForIdField(filters?.['bankId']),
      AdxInvoiceId: this.extractFilterValue(filters?.['invoiceId']) ?? '',
      ClientName: getAutocompleteValue(filters?.['clientName']),
      TripId: filters?.['tripId'] ?? '',
      AdxInvoiceRecordLocator: getAutocompleteValue(filters?.['adxInvoiceRecordLocator']),
    };

    removeEmptyParams(params);
      return this.http.get<GridServiceResponse<AdxPaymentResponse>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }

  private getMappedPaymentPropertyName(propertyName: string): string {
    switch (propertyName) {
      case 'fmsAdxPaymentDetailId':
        return 'Id';
      case 'vendorName':
        return 'adxBooking.Vendor.VendorName';
      case 'payTypeName':
        return 'payType.PayTypeName';
      case 'payMethodName':
        return 'payMethod.PaymethodName';
      case 'profileTypeName':
        return 'profileType.ProfileTypeName';
      case 'branchName':
        return 'branch.Name';
      case 'bankName':
        return 'bank.Name';
      case 'tripExternalReference':
        return 'trip.ExternalReference';
        case 'adxInvoiceRecordLocator':
        return 'trip.ExternalReference';
      case 'tripRecordLocator':
        return 'trip.ExternalReference';
      case 'dateUpdated':
        return 'DateUpdated';
      default:
        return propertyName;
    }
  }
}
